import React from 'react'
import VideoPlayerModal from '@shared/innmaxUI/VideoPlayer'

import { ICamera } from '@services/device'

export type Props = {
  device: any | ICamera
  onRequestClose?: (d: any) => void
  onClose?: (d: any) => void
}

export default function LiveCCTVModal({
  device,
  onRequestClose,
  onClose,
}: Props) {
  const fieldProps = {
    device,
    onRequestClose,
    onClose,
  }

  return <VideoPlayerModal isOpen {...fieldProps} />
}
